(ns motorsaif.log
  (:require
   [taoensso.telemere :as t]))

(defn error
  [& data]
  (t/log! :warn (apply str data)))

(defn info
  [& data]
  (t/log! :info (apply str data)))

(defn debug
  [data]
  (t/log! :debug (apply str data)))
